var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"sidebar-logo",class:{ minimized: _vm.minimized },attrs:{"to":"/dashboard"}},[_c('logo-icon',{attrs:{"minimized":_vm.minimized}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }